var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBakeryDining = function SvgBakeryDining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "bakery_dining_svg__a",
    width: 25,
    height: 25,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 .094h24.093v24.093H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bakery_dining_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.852 17.11q.855.452 1.43-.239.579-.69.151-1.517l-1.982-3.716-1.782 4.393zm-5.37-.853h2.283l2.384-6.1q.25-.576.1-1.003a.9.9 0 0 0-.602-.577L16.639 7.8q-.527-.25-.966-.076-.439.175-.464.753zm-7.154 0h2.284l-.728-7.856Q8.86 8 8.421 7.774q-.44-.225-.992.025l-1.983.778a.86.86 0 0 0-.553.665q-.1.49.102.992zm-3.086.853 2.182-1.105-1.756-4.392-1.907 3.815q-.452.83.125 1.443.577.615 1.356.239m6.199-.853h3.211l.83-9.01q.024-.527-.252-.866t-.828-.338h-2.71q-.453 0-.79.313a.9.9 0 0 0-.29.79zM3.79 18.113q-.88 0-1.48-.551a1.8 1.8 0 0 1-.603-1.38q0-.252.025-.49.024-.239.15-.44l2.409-4.668q-.476-.778-.213-1.606.264-.827 1.092-1.154l1.983-.803q.427-.201.89-.176.465.025.816.352-.05-.879.502-1.431t1.356-.552h2.66q.777 0 1.355.528.577.525.553 1.354.275-.376.752-.302.476.076.879.227l2.007.803q.752.326 1.017 1.13.263.803-.088 1.63l2.384 4.668q.1.177.15.352.05.176.05.352 0 .852-.602 1.506-.601.651-1.455.651-.252 0-.465-.062a1.7 1.7 0 0 1-.413-.188l-1.556-.804H6.174l-1.582.778q-.2.077-.388.176a.9.9 0 0 1-.414.1"
  }))));
};
export default SvgBakeryDining;